document.addEventListener('DOMContentLoaded', () => {
   const header = document.querySelector('.wcl-header');
   let lastScrollY = window.scrollY;
   let ticking = false;

   window.addEventListener('scroll', () => {
      if (!ticking) {
         requestAnimationFrame(() => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY && currentScrollY > 80) {
               header.classList.add('is-hidden');
            } else {
               header.classList.remove('is-hidden');
            }

            lastScrollY = currentScrollY;
            ticking = false;
         });

         ticking = true;
      }
   });
});